import React from "react"

export const DoggyCompanion = () => {
    return <div className="dog-container">
        <div className="dog">
            <div className="dog-body">
                <div className="dog-tail">
                    <div className="dog-tail">
                        <div className="dog-tail">
                            <div className="dog-tail">
                                <div className="dog-tail">
                                    <div className="dog-tail">
                                        <div className="dog-tail">
                                            <div className="dog-tail"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="stripes back-1"></div>
            </div>
            <div className="dog-torso">
                <div className="stripes back-2"></div>
            </div>
            <div className="dog-head">
                <div className="stripes face-1"></div>
                <div className="stripes face-2"></div>
                <div className="stripes face-3"></div>
                <div className="stripes face-4"></div>
                <div className="dog-ears">
                    <div className="dog-ear"></div>
                    <div className="dog-ear"></div>
                </div>
                <div className="dog-eyes">
                    <div className="dog-eye"></div>
                    <div className="dog-eye"></div>
                </div>
                <div className="dog-muzzle">
                    <div className="stripes face-5"></div>
                    <div className="dog-nose"></div>
                    <div className="dog-sniff"></div>
                </div>
                <div className="dog-tongue"></div>
            </div>
        </div>
    </div>
}